module.exports = __webpack_public_path__ + "img/plus-icon.050a37ae.svg";